const dayjs = require('dayjs');

var defaults = {
    file: require('./source.json'),
    ajax: false,
    geoloc: false,
    enableTitlesResults : true,
    researchOn : [
        'magasins',
        'departements',
        'regions'
    ],
    url: '',
    localStoragePrefix : '',
    refreshMagasins: 2,
    token: '',
    researchStart: 2,
    elements: {
        select: '',
        input: '',
        magasins_overlay: '',
        toggle_overlay_magasins: '',
        form_wrapper: '',
        magasins_close_overlay: '',
        geoloc: '',
        mapName: '',
        // search_text: '',
        wrapperUi: '',
        basicAppend: ''
    },
    maxHeight: 150,
    suggestion: '',
    inputs: {
        type: 'hidden',
        prefix: 'myawesome_',
        names: [
            'pays',
            'region',
            'departement',
            'magasin',
        ]
    },
    labels: {
        select: 'Votre pays',
        input: 'Votre Région, Département, Ville...',
        departements: 'Département',
        magasins: 'Magasin',
        regions: 'Région',
        noresults: 'Aucun résultat pour cette recherche.',
        add: 'Ajouter',
        remove: 'Retirer'
    },
    markup: {
        wrapper: {
            tag: 'div',
            attrs: {
                class: 'rechercheUI-component',
                id: "results_checking"
            }
        },
        results: {
            tag: 'div',
            attrs: {
                class: 'results',
                hidden: 'hidden'
            }
        },
        results_ul: {
            tag: 'ul',
            attrs: {
                class: 'results_ul'
            }
        },
        result_label: {
            tag: 'li',
            attrs: {
                class: 'result_label'
            }
        },
        result: {
            tag: 'li',
            attrs: {
                class: 'result'
            }
        },
        result_string_match: {
            tag: 'span',
            attrs: {
                class: 'result_match'
            }
        },
        no_results: {
            tag: 'li',
            attrs: {
                class: 'no_results'
            }
        },
        overlay: {
            tag: 'div',
            attrs: {
                class: 'overlay_as_mobile'
            }
        }
    },
    store: {
        datas: {},
        selected_magasin: [],
        limit_magasin: 1,
        filter_datas: {},
        select_pays_id: 0
    },
    latinize: require('latinize'),
    slugify: require('slugify'),
    querystring: require('query-string')


}


var defaults_hooks = {
    init: (element) => {},
    ready: (element) => {},
    beforeOpen: (element) => {},
    open: (element) => {},
    showMap: (element) => {},
    hideMap: (element) => {},
    onFinishedResearch: (instance,datas) => {},

    onSelectMagasin: (instance, magasin) => {},
    onUnselectMagasin: (instance, magasin) => {},
    onSaveMagasin: (instance, magasin) => {},
    onUnsaveMagasin: (instance, magasin) => {},
    beforeClose: (element) => {},
    close: (element) => {},
    onSelect: (element) => {},
    onFocus : (element) => {},
    onBlur : (element) => {},
    onChange: (element) => {},
    onTyping: (element) => {},
    addCreateRenderer: (element) => {},
    setCenterSearch: (data) => {}
}

class rechercheUi {
    constructor(opts) {
        this.onSearch = false;
        this.map = undefined;
        this.options = Object.assign({}, defaults, opts.options),
            this.hooks = Object.assign({}, defaults_hooks, opts.hooks)
    }

    bindPopup(magasin_id) {
        let keyLayers = Object.keys(this.map._layers);
        for (let index = 0; index < keyLayers.length; index++) {
            const key = keyLayers[index];
            const layer = this.map._layers[key];
            if (layer.options && layer.options.mid && layer.options.mid == magasin_id) {
                layer.fire('click');
                break;
            }
        }
    }
    getLocalStoragePrefix() {
        return $('html').attr('lang')+'_'+this.options.localStoragePrefix;
    }
    getFromLocalStorage(key) {

        let prefix = this.getLocalStoragePrefix();

        return localStorage.getItem(prefix+'_'+key);
    }
    setToLocalStorage(key, value) {

        let prefix = this.getLocalStoragePrefix();

        localStorage.setItem(prefix+'_'+key, value);
        return this;
    }
    clearFromLocalStorage(key) {
        let prefix = this.getLocalStoragePrefix();
        localStorage.removeItem(prefix+'_'+key);
        return this;
    }
    makeUrl() {
        let start = Date.now();
        this.setToLocalStorage('selected_magasin_timestamp', start);
        //localStorage.setItem('selected_magasin_timestamp', start);

        let objQuery = {}
        const QueryString = this.options.querystring;
        let Locale = Lang.locale;
        let baseUrl = route('front.resultats-recherche.' + Locale).template;


        let translator = {
            home_region_id: 'region',
            home_departement_id: 'departement',
            home_pays_id: 'pays',
            home_magasin_id: 'magasin'
        }

        let StorageKeys = [
            'home_region_id',
            'home_departement_id',
            'home_pays_id',
            'home_magasin_id'
        ]

        for (let index = 0; index < StorageKeys.length; index++) {
            const storageKey = StorageKeys[index];
            let keyFromStorage = this.getFromLocalStorage(storageKey);
            if (keyFromStorage != null) {
                objQuery[translator[storageKey]] = keyFromStorage;
            }
        }

        let query = QueryString.stringify(objQuery);

        return query.length > 0 ? baseUrl + '?' + query : baseUrl;
    }
    openPopup(object) {
        var that = this;
        let Locale = Lang.locale;
        let mag = object.magasin;
        let routeMag = route('fiche-magasin.' + Locale).template;

        let slugMag = that.options.slugify(mag.nom, {
            replacement: '-', // replace spaces with replacement character, defaults to `-`
            remove: undefined, // remove characters that match regex, defaults to `undefined`
            lower: true, // convert to lower case, defaults to `false`
            strict: false, // strip special characters except replacement, defaults to `false`
            locale: Locale // language code of the locale to use
        })

        let selection_mag = undefined;
        routeMag = routeMag.replace('{slug}', slugMag).replace('{magasinId}', mag.id);
        let imageIconObject = object.icon;
        let toggle_overlay_magasins = document.querySelector(that.options.elements.toggle_overlay_magasins);
        let input_autocomplete = document.querySelector(that.options.elements.input)
        // console.log(mag)
        let template = `<div class="card js-card-liste-magasin">

            <div class="card-body">
                <div class="line">
                    <b class="name-magasin"><a href="${routeMag}" class="text-dark">${mag.nom}</a></b>
                        
                    <p class="address">
                        <a href="${routeMag}" class="text-dark">
                        ${mag.adresse_1} <br>
                        ${mag.code_postal} ${mag.ville}
                        </a>
                    </p>
        
                    <p class="state-magasin ${mag.statutOuvertureStr.ouvert ? 'open' : 'closed'}  w-100">
                        <span class="circle"></span>  ${mag.statutOuvertureStr.message}
                    </p>

                    <a href="#" class="btn btn-black line-yellow js-toggle-selection">${that.isInSelection(mag) == true ? this.options.labels.remove : this.options.labels.add}</a>
                    <div id="mag_${mag.id}" data-rid="${mag.region_id}" data-pid="${mag.pays_id}" data-did="${mag.departement_id}" data-code-postal="${mag.code_postal}" data-mid="${mag.id}" data-reference="magasins" class="d-none">${mag.nom}</div>
                </div>
            </div>
        
        </div>`;

        object.popup.setContent(template);
        // console.log('object.icon', object.icon)

        let btnToggleSelection = object.popup._container.querySelector('.js-toggle-selection');
        // console.log('btnToggleSelection', btnToggleSelection)

        selection_mag = that.getSelectedMagasin();

        btnToggleSelection.addEventListener('click', function (e) {
            e.preventDefault();
            // let hasDisabled = this.hasAttribute('disabled')
            // if (hasDisabled) {
            //     return false;
            // }

            selection_mag = that.getSelectedMagasin();
            // console.log(selection_mag)
            // return false;

            imageIconObject.setIcon(
                that.isInSelection(mag) ? object.icons.big : object.icons.default
            );
            imageIconObject._icon.classList[that.isInSelection(mag) ? 'add' : 'remove']('selected_mag')

            if (that.isInSelection(mag) === false) {
                this.textContent = that.options.labels.remove
                that.clearSelection();
                that.addInSelection(mag)

                that.hooks.onSelectMagasin(that, mag);

                if (that.options.elements.input && that.options.elements.input.length > 0) {
                    that.sendInformations(this.nextElementSibling);
                    that.changeInformations(this.nextElementSibling);
                    toggle_overlay_magasins.style.display = 'none';
                }

                let saveMagasinSession = route('select.magasin.session').template;
                saveMagasinSession = saveMagasinSession.replace('{magasinId}', mag.id)
                // console.log(`${mag.pays_id}`)
                // that.loadMap(`${mag.pays_id}`);

                that.makeRequest({
                    credentials: true,
                    method: 'GET',
                    url: saveMagasinSession,
                    cache: false,
                    async: true,
                    dataType: 'json',
                    header: {
                        'Access-Control-Allow-Origin': '*',
                        'X-CSRF-TOKEN': that.options.token
                    },
                    data: {}
                }, function (err, datas) {
                    if (err) {
                        //console.log(datas)
                        return false;
                    }
                    that.hooks.onSaveMagasin(that, mag);
                    window.location = that.makeUrl();

                    //
                    // ajaxSliderDate
                    // si on a besoin du formulaire avec le magasin_id. Décommentez cette ligne suivante:
                    // document.forms.formResearchMagasins.submit();
                })

            } else {
                this.textContent = that.options.labels.add
                that.hooks.onUnselectMagasin(that, mag);
                that.clearSelection()
                that.clearStorage();

                if (that.options.elements.toggle_overlay_magasins && that.options.elements.toggle_overlay_magasins.length > 0) {
                    toggle_overlay_magasins.style.display = '';
                }
                if (that.options.elements.input && that.options.elements.input.length > 0) {
                    input_autocomplete.value = '';
                }

                let deselectMagasinSession = route('deselect.magasin.session').template;
                deselectMagasinSession = deselectMagasinSession.replace('{magasinId}', mag.id)

                //genere un bug coté php Voir avec Léo
                that.makeRequest({
                    credentials: true,
                    method: 'GET',
                    url: deselectMagasinSession,
                    async: true,
                    cache: false,
                    dataType: 'json',
                    header: {
                        'Access-Control-Allow-Origin': '*',
                        'X-CSRF-TOKEN': that.options.token
                    },
                    data: {}
                }, function (err, datas) {
                    if (err) {
                        //console.log(datas)
                        return false;
                    }

                    that.hooks.onUnsaveMagasin(that, mag);
                })
            }



        })

    }
    clearStorage() {
        // this.getFromLocalStorage(

        this.clearFromLocalStorage('home_pays_name');
        this.clearFromLocalStorage('home_pays_id');

        this.setToLocalStorage('search_type', 'pays');

        this.clearFromLocalStorage('for_search_field');
        this.clearFromLocalStorage('home_magasin_name');
        this.clearFromLocalStorage('home_magasin_id');

        this.clearFromLocalStorage('home_departement_name');
        this.clearFromLocalStorage('home_departement_id');

        this.clearFromLocalStorage('home_region_name');
        this.clearFromLocalStorage('home_region_id');
    }
    clearSelection() {
        this.options.store.selected_magasin = [];
    }
    addInSelection(magasin) {
        this.options.store.selected_magasin.push(magasin);
    }
    isInSelection(magasin) {
        let ret = false;
        let selecteds = this.options.store.selected_magasin;
        if (selecteds.length > 0) {
            for (let index = 0; index < selecteds.length; index++) {
                const selected = selecteds[index];
                if (selected.id === magasin.id) {
                    ret = true;
                }
            }
        }
        return ret;
    }
    getSelectedMagasin() {
        return this.options.store.selected_magasin;
    }
    getZoomButtons() {
        let magasins_overlay = this.getElement('magasins_overlay');
        if (magasins_overlay != undefined) {
            let template = `<div class="leaflet-touch custom_leaflet_control">
            <div class="leaflet-control-zoom leaflet-bar leaflet-control">
                <a class="leaflet-control-zoom-in js-custom-control" data-zoom="+" href="#" title="Zoom in" role="button" aria-label="Zoom in">+</a>
                <a class="leaflet-control-zoom-out js-custom-control" data-zoom="-" href="#" title="Zoom out" role="button" aria-label="Zoom out">−</a>
            </div></div>
        `;

            magasins_overlay.insertAdjacentHTML('afterbegin', template);
            var that = this;

            let controls = [...document.querySelectorAll('.js-custom-control')];

            for (let index = 0; index < controls.length; index++) {
                const control = controls[index];

                control.addEventListener('click', function (e) {
                    e.preventDefault();
                    let data = this.getAttribute('data-zoom');
                    let newZoom = that.map.getZoom();
                    if (data == "+") {
                        newZoom = newZoom + 2;
                    } else {
                        newZoom = newZoom - 2;
                    }
                    that.map.setZoom(newZoom)
                })

            }
        }


    }
    loadMap(forcePayId) {
        var payId = undefined;
        if (forcePayId && forcePayId.length > 0) {
            payId = forcePayId;
        } else {
            var select = document.querySelector(this.options.elements.select);
            payId = select.options[select.selectedIndex].getAttribute('data-pid');
        }
        // console.log(select.selectedIndex)


        // console.log('payId', payId)
        var pays = undefined;
        var magasins = undefined;
        var map = undefined;
        var that = this;

        if (payId != '0') {
            magasins = this.filterMagasinsBy('pays_id', parseInt(payId))
            pays = this.getPays(payId)
        } else {
            // par defaut on centre selon la langue du user
            let thePaysId = this.getPaysIdByLang();
            pays = this.getPays(thePaysId != null ? thePaysId : '58');
            magasins = this.getMagasins()
        }
        //console.log('magasins', magasins)
        //console.log('pays', pays)

        if (this.map != undefined) {
            // console.log(this)
            // console.log(this.map)
            this.map.eachLayer((layer) => {
                this.map.removeLayer(layer);
            });
            this.map.flyTo([pays.lat, pays.lng], pays.zoom);
        } else {
            map = L.map(this.options.elements.mapName, {
                zoomControl: false,
            }).setView([pays.lat, pays.lng], pays.zoom);
        }

        // if (payId != '0') {
        let trocIcon = L.icon({
            iconUrl: '/images/locator-troc.svg',
            iconSize: [48, 48]
        });
        let trocIconBig = L.icon({
            iconUrl: '/images/locator-troc.svg',
            iconSize: [64, 64]
        });
        let happytrocIcon = L.icon({
            iconUrl: '/images/locator-happytroc.png',
            iconSize: [48, 48]
        });
        let happytrocIconBig = L.icon({
            iconUrl: '/images/locator-happytroc.png',
            iconSize: [64, 64]
        });
        let trocanteIcon = L.icon({
            iconUrl: '/images/locator-latrocante.png',
            iconSize: [48, 48]
        });
        let trocanteIconBig = L.icon({
            iconUrl: '/images/locator-latrocante.png',
            iconSize: [64, 64]
        });

        popupStatic = '<p style="height:40px; width:40px">-</p>';

        for (let index = 0; index < magasins.length; index++) {
            const magasin = magasins[index];

            let inSelection = that.isInSelection(magasin)
            let icon = inSelection ? trocIconBig : trocIcon;
            if (magasin.marque == 'Happy Troc') {
                icon = inSelection ? happytrocIconBig : happytrocIcon;
            } else if (magasin.marque == 'La Trocante') {
                icon = inSelection ? trocanteIconBig : trocanteIcon;
            }
            let marker = L.marker([magasin.lat, magasin.lng], {
                pid: payId,
                mid: magasin.id,
                icon: icon
            });
            marker.addTo(typeof this.map === 'object' ? this.map : map).bindPopup(popupStatic, {
                minWidth: 400
            }).on('click', function (e) {
                var latlng = [magasin.lat, magasin.lng];
                var popup = e.target.getPopup();
                var icon = e.target;
                var icons = {
                    default: trocIcon,
                    big: trocIconBig
                }
                if (magasin.marque == 'Happy Troc') {
                    icons = {
                        default: happytrocIcon,
                        big: happytrocIconBig
                    }
                } else if (magasin.marque == 'La Trocante') {
                    icons = {
                        default: trocanteIcon,
                        big: trocanteIconBig
                    }
                }
                that.openPopup({
                    magasin,
                    pays,
                    icon,
                    icons,
                    popup,
                    latlng
                })
            });

            marker._icon.classList[inSelection ? 'add' : 'remove']('selected_mag')

        }
        // }

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(typeof this.map === 'object' ? this.map : map);

        if (this.map == undefined) {
            this.map = map;
        }

    }
    getMagasins() {
        return this.options.store.datas.magasins;
    }
    getMagasin(magasin_id) {
        let ret = {};
        let magasins = this.options.store.datas.magasins;
        for (let index = 0; index < magasins.length; index++) {
            const magasin = magasins[index];
            if (magasin.id == magasin_id) {
                ret = magasin;
            }
        }
        return ret;
    }
    getPays(pay_id) {
        let ret = {};
        let pays = this.options.store.datas.pays;
        for (let index = 0; index < pays.length; index++) {
            const pay = pays[index];
            if (pay.id == pay_id) {
                ret = pay;
            }
        }
        return ret;
    }

    filterMagasinsBy(key, searchable) {
        var ret = [];
        let magasins = this.options.store.datas.magasins;

        for (let index = 0; index < magasins.length; index++) {
            const magasin = magasins[index];
            // console.log('magasin by '+key, magasin[key])
            // console.log('search by '+key, searchable)
            let srcKeyMag = undefined

            if(typeof searchable == 'string') {
                searchable = searchable.toLowerCase().trim();
                srcKeyMag = magasin[key].toLowerCase();
            }
            else {
                srcKeyMag = magasin[key]
            }

            if (srcKeyMag == searchable) {
                ret.push(magasin);
            }
        }
        return ret;
    }

    makeRequest(options, callback) {
        var request = new XMLHttpRequest();
        request.open(options.method, options.url, options.async);
        // request.setRequestHeader("Access-Control-Allow-Origin", "*");
        request.withCredentials = options.credentials;
        request.responseType = options.dataType;


        let keysHeader = Object.keys(options.header);

        for (let index = 0; index < keysHeader.length; index++) {
            const keyHeader = keysHeader[index];
            request.setRequestHeader(keyHeader, options.header[keyHeader])
        }

        request.onload = function (e) {

            if (this.status >= 200 && this.status < 400) {
                callback(false, request.response)
            } else {
                callback(true, e)
            }

        }

        request.onerror = function (e) {
            // There was a connection error of some sort
            callback(true, e)
        };

        request.send();
    }
    diff_hours(dt2, dt1) {

        var diff = (dt2.getTime() - dt1.getTime()) / 1000;
        diff /= (60 * 60);
        return Math.abs(Math.round(diff));

    }
    init() {
        this.hooks.init();
        this.wireElements();

        const input = this.getElement('input');
        var select = this.getElement('select');
        var all = [select, input];

        for (let index = 0; index < all.length; index++) {
            const element = all[index];
            element.removeAttribute('disabled');
            element.classList.remove('disabled');
        }

        var that = this;

        // fix temporaire
        if (this.options.file && this.options.file.length > 0 && this.options.ajax === false) {
            // console.log(this.options.file);
            this.options.store.datas = this.options.file

            this.makeInitProcess();
            // this.stickyResultsLabel();

        } else {

            let dateAjaxCheck = that.getFromLocalStorage('ajaxMagDate');
            // console.log('dateAjaxCheck', dateAjaxCheck)

            if (dateAjaxCheck != null) {
                // console.log('a')
                // Une requete est deja passée et sauvée
                let diff = this.diff_hours(new Date(Number(dateAjaxCheck)), new Date());
                // console.log('diff', diff)
                if (diff >= this.options.refreshMagasins) {
                    // console.log('b')
                    this.makeInitRequest(true);
                } else {
                    // console.log('c')
                    // pas besoin de faire de request
                    let one = JSON.parse(that.getFromLocalStorage('ajaxMagResponse'));
                    // console.log( JSON.parse( one[0] ) )
                    this.options.store.datas = JSON.parse(one[0]);
                    this.makeInitProcess()
                }
            } else {
                // console.log('d')
                this.makeInitRequest(true);
            }


        }
    }
    makeInitProcess() {
        var that = this;
        that.alimSelect();
        that.generateListRenderer();
        that.basicAutocomplete();
        // that.getCorrectEmplacementUI();
        that.hiddenFields();
        that.overlay('init');
        that.getZoomButtons();
        that.setInformationsFromStorage();
        that.registerListeners();

        if (that.options.geoloc) {
            that.requestGeoloc();
        }
        that.hooks.ready(that);
    }
    makeInitRequest(save = false) {
        var that = this;

        this.makeRequest({
            credentials: true,
            method: 'GET',
            url: this.options.url,
            cache: false,
            async: true,
            dataType: 'json',
            header: {
                'Access-Control-Allow-Origin': '*',
                'X-CSRF-TOKEN': this.options.token
            },
            data: {}
        }, function (err, datas) {

            if (err) {
                //console.log('error', datas)
                return false;
            }

            if (save) {
                let dateAjax = new Date();
                that.setToLocalStorage('ajaxMagDate', dateAjax.getTime());
                that.setToLocalStorage('ajaxMagResponse', JSON.stringify([datas]));
            }

            var resp = JSON.parse(datas);

            // console.log('resp', resp)

            that.options.store.datas = resp;
            // console.log(that.options.store);
            that.makeInitProcess();


        })
    }


    requestGeoloc(force = false) {
        var that = this;
        let Locale = Lang.locale;
        let geoloc_user_storage = this.getFromLocalStorage('geoloc_user');
        if (!geoloc_user_storage) {
            // On demande la geoloc :
            navigator.geolocation.getCurrentPosition(function (data) {
                let geoloc_user_prevented = that.getFromLocalStorage('geoloc_user_prevented')
                if (geoloc_user_prevented == null || force == true) {
                    that.clearStorage();
                }

                that.setToLocalStorage('geoloc_user', `${data.coords.latitude},${data.coords.longitude}`);
                that.setToLocalStorage('geoloc_user_prevented', 'yes');

                if (geoloc_user_prevented == null || force == true) {
                    window.location = route('front.resultats-recherche.' + Locale) + `?location=${data.coords.latitude},${data.coords.longitude}&top_proche=1&top_magasin_favori=0`;
                }
            }, function (data) {
                // En cas de refus, on vire le bouton de geoloc:
                let geoloc_btn = that.getElement('basicAppend');
                $(geoloc_btn).addClass('no-geoloc');
                $(geoloc_btn).find('.js-geoloc').parent().addClass('d-none');
                $(geoloc_btn).find('.js-geoloc').parent().remove();
            });
        } else if (force == true) {
            window.location = route('front.resultats-recherche.' + Locale) + "?location=" + geoloc_user_storage + "&top_proche=1&top_magasin_favori=0";
        }
    }
    wireElements() {
        let elements = this.get('elements');
        this.elements = {};
        let keyElements = Object.keys(elements);

        for (let index = 0; index < keyElements.length; index++) {
            let key = keyElements[index];
            const element = elements[key];
            // console.log('element wire', element);
            this.elements[key] = this.getQuerySelector(element);
        }
    }
    getElement(key) {
        return this.elements[key];
    }
    getQuerySelector(selector) {
        let sel = null;
        if (selector && selector.length > 0) {
            let selQuery = document.querySelectorAll(selector);

            if (selQuery.length === 1) {
                sel = selQuery[0];
            } else {
                sel = selQuery;
            }
        }
        return sel;
    }
    get(str) {
        let rt;
        switch (str) {
            case 'elements':
                rt = this.options.elements;
                break;
            case 'options':
                rt = this.options;
                break;
            case 'markup':
                rt = this.options.markup;
                break;
            case 'labels':
                rt = this.options.labels;
                break;
            case 'store':
                rt = this.options.store;
                break;
        }

        return rt;
    }
    isQueryableFromDom(stringDom) {
        let ret = false;
        if (stringDom && stringDom.length > 0) {
            ret = true;
        }
        return ret;
    }
    setInformationsFromStorage() {
        let prefix = this.getLocalStoragePrefix();
        var keysStorageIds = ['home_magasin_id', 'home_departement_id', 'home_region_id', 'home_pays_id'];
        var inputs = ['#myawesome_magasin', '#myawesome_departement', '#myawesome_region', '#myawesome_pays'];

        var keysStorageName = ['home_magasin_name', 'home_departement_name', 'home_region_name', 'home_pays_name'];

        for (let index = 0; index < keysStorageIds.length; index++) {
            const id = keysStorageIds[index];
            var curr_id = this.getFromLocalStorage(id);
            // console.log('id', id)
            // console.log('curr_id', curr_id)

            if (curr_id && curr_id.length > 0) {
                if (prefix+'_'+id === prefix+'_home_magasin_id') {
                    let mag = this.getMagasin(curr_id);
                    this.addInSelection(mag);
                    console.log(this.options.elements.toggle_overlay_magasins);
                    if (this.isQueryableFromDom(this.options.elements.toggle_overlay_magasins)) {
                        let fakebtnsubmit = this.getElement('toggle_overlay_magasins');
                        fakebtnsubmit.style.display = 'none';
                    }

                }
                let cibledElm = document.querySelector(inputs[index]);
                if (cibledElm != null) {
                    cibledElm.value = curr_id;
                }
            }
        }



        var search_query = this.getFromLocalStorage('search_type');

        var s_pays_id = this.getFromLocalStorage('home_pays_id');
        var s_field = this.getFromLocalStorage('for_search_field');

        if (s_pays_id) {

            this.options.store.select_pays_id = parseInt(s_pays_id);

            if (this.isQueryableFromDom(this.options.elements.select)) {
                var select = this.getElement('select');

                select.options[select.selectedIndex].removeAttribute('selected');

                var new_selected = document.querySelector('#pays_list option[data-pid="' + s_pays_id + '"]');

                new_selected.setAttribute('selected', 'selected');
            }


        }

        if (s_field) {
            if (this.isQueryableFromDom(this.options.elements.input)) {
                var auto_input = this.getElement('input');
                auto_input.value = this.getFromLocalStorage('for_search_field');
            }
        }
    }
    overlay(str, callback) {
        var markup = this.get('markup');
        var tlOverlay = new TimelineMax();
        tlOverlay.timeScale(1.2)


        switch (str) {
            case 'init':
                this.create(markup.overlay);
                break;
            case 'open':
                var ov = document.querySelector('.' + markup.overlay.attrs.class);
                var blockToAppend = document.querySelector('.search-form-desktop-container.v2');
                var offsetTop = blockToAppend.getBoundingClientRect().top;
                // console.log('offsetTop', offsetTop);
                // ov.appendChild(blockToAppend);
                var blocks = ['.achat-choice', '.vente-choice'];
                this.transforms = [];
                for (let index = 0; index < blocks.length; index++) {
                    const block = blocks[index];
                    var save_css_transform = document.querySelector(block).style.transform;
                    this.transforms.push(save_css_transform);
                    document.querySelector(block).style.transform = "";

                }

                // console.log(tlOverlay)
                tlOverlay.fromTo('.' + markup.overlay.attrs.class, 0.3, {
                    position: "absolute",
                    autoAlpha: 0,
                    top: 'auto',
                    y: 0,
                    display: "none",
                    ease: Circ.easeInOut
                }, {
                    position: "absolute",
                    autoAlpha: 1,
                    top: 0,
                    left: 0,
                    right: 0,
                    display: "block",
                    y: 0,
                    ease: Circ.easeInOut
                });
                tlOverlay.fromTo(blockToAppend, 0.1, {
                    position: "fixed",
                    top: offsetTop,
                    left: 'auto',
                    right: 'auto',
                    display: "block",
                    ease: Circ.easeInOut
                }, {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    display: "block",
                    zIndex: 100,
                    ease: Circ.easeInOut,
                    onComplete: callback
                });

                ov.classList.add('open');
                document.body.classList.add('body-lock');

                break;
            case 'close':
                var ov = document.querySelector('.' + markup.overlay.attrs.class);
                var blockToAppend = document.querySelector('.search-form-desktop-container.v2');
                var offsetTop = document.querySelector('.achat-choice').getBoundingClientRect().top;
                document.querySelector('.achat-choice').insertBefore(blockToAppend, document.querySelector('.localisation'));
                tlOverlay.fromTo('.' + markup.overlay.attrs.class, 0.3, {
                    position: "absolute",
                    autoAlpha: 1,
                    top: 0,
                    left: 0,
                    right: 0,
                    display: "block",
                    y: 0,
                    ease: Circ.easeInOut
                }, {
                    position: "absolute",
                    autoAlpha: 0,
                    top: 'auto',
                    y: 0,
                    display: "none",
                    ease: Circ.easeInOut
                });
                tlOverlay.fromTo(blockToAppend, 0.1, {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    display: "block",
                    zIndex: 100,
                    ease: Circ.easeInOut
                }, {
                    position: "fixed",
                    top: offsetTop,
                    left: 0,
                    right: 0,
                    display: "block",
                    ease: Circ.easeInOut,
                    onComplete: callback
                });
                ov.classList.remove('open');



                document.body.classList.remove('body-lock');
                break;
        }

    }
    isOpenedOverlay() {
        var markup = this.get('markup');

        var ov = document.querySelector('.' + markup.overlay.attrs.class);
        return ov.classList.contains('open');
    }
    hiddenFields() {
        var inputs = this.options.inputs;
        var markup = this.options.markup;
        var wrapper = document.querySelector('.' + markup.wrapper.attrs.class);

        for (let index = 0; index < inputs.names.length; index++) {
            const input = inputs.names[index];
            var gen_input = document.createElement('input');
            gen_input.setAttribute(inputs.type, inputs.type)
            gen_input.setAttribute('name', input);
            gen_input.setAttribute('id', inputs.prefix + input);
            wrapper.appendChild(gen_input);

        }
    }
    alimSelect() {
        let allPays = undefined;
        if (navigator.userAgent.indexOf('MSIE') !== -1 ||
            navigator.appVersion.indexOf('Trident/') > -1) {
            /* Microsoft Internet Explorer detected in. */
            const DATAS = JSON.parse(this.options.store.datas);
            allPays = DATAS.pays;
        } else {
            allPays = this.options.store.datas.pays;
        }

        // console.log("allpays", allPays)
        var fragment = document.createDocumentFragment();
        var select = this.getElement('select');

        var optionFirst = document.createElement('option');
        optionFirst.setAttribute('data-pid', 0);
        optionFirst.setAttribute('selected', 'selected');
        optionFirst.textContent = this.options.labels.select;
        fragment.appendChild(optionFirst);

        for (let index = 0; index < allPays.length; index++) {
            const pays = allPays[index];
            var option = document.createElement('option');
            option.setAttribute('data-pid', pays.id);
            option.textContent = pays.libelle;
            fragment.appendChild(option);

        }
        select.appendChild(fragment);

    }
    generateListRenderer() {
        var markupKeys = Object.keys(this.options.markup);
        // console.log('markupKeys', markupKeys)

        for (let index = 0; index < markupKeys.length; index++) {
            const markup = markupKeys[index];
            this.options.markup[markup].name = markup;
        }
        // console.log(this.options.markup);
    }
    basicAutocomplete() {
        var input = this.getElement('input');
        input.setAttribute('placeholder', this.options.labels.input);
        var markup = this.options.markup;

        var basic = [markup.wrapper, markup.results, markup.results_ul]

        for (let index = 0; index < basic.length; index++) {
            const element = basic[index];
            this.create(element);
        }

    }
    addRenderer(name, obj) {
        return this.options.markup[name] = obj;
    }
    generateAttr(elm, obj) {
        for (const attribute in obj) {
            if (obj.hasOwnProperty(attribute)) {
                const attr = obj[attribute];
                elm.setAttribute(attribute, attr);
            }
        }
    }
    retrieve(key, id) {
        let APIDATAS;
        // const APIDATAS = this.options.store.datas;
        if (navigator.userAgent.indexOf('MSIE') !== -1 ||
            navigator.appVersion.indexOf('Trident/') > -1) {
            /* Microsoft Internet Explorer detected in. */
            APIDATAS = JSON.parse(this.options.store.datas);
        } else {
            APIDATAS = this.options.store.datas;
        }
        let rt = undefined;
        for (let index = 0; index < APIDATAS[key].length; index++) {
            const selection = APIDATAS[key][index];
            if (id === selection.id) {
                rt = selection;
            }
        }
        return rt;
    }
    create(obj, passDatas) {
        // var frag = document.createDocumentFragment();
        var generated_content;
        // console.log('array', array)

        if (obj.name && obj.name != "") {
            var input = document.querySelector(this.options.elements.input);
            var markup = this.options.markup;
            var labels = this.options.labels;


            if (obj.name === "wrapper") {
                var wrapper = document.createElement(markup.wrapper.tag)
                // wrapper.setAttribute(markup.wrapper.tag)
                var attrs = markup.wrapper.attrs;
                this.generateAttr(wrapper, attrs);

                input.parentNode.appendChild(wrapper);
                wrapper.appendChild(input);
            }

            if (obj.name === "results") {
                var wrapper = document.querySelector('.' + markup.wrapper.attrs.class);
                var results_tag = document.createElement(markup.results.tag)

                var attrs = markup.results.attrs;
                this.generateAttr(results_tag, attrs);
                wrapper.appendChild(results_tag);
            }

            if (obj.name === "results_ul") {
                var results_inner = document.querySelector('.' + markup.results.attrs.class);
                var results_tag_inner = document.createElement(markup.results_ul.tag);

                if (this.options.maxHeight && this.options.maxHeight != 0) {
                    results_tag_inner.setAttribute('style', 'max-height:' + this.options.maxHeight + 'px');

                }

                var attrs = markup.results_ul.attrs;
                this.generateAttr(results_tag_inner, attrs);

                if (this.options.maxHeight && this.options.maxHeight != 0) {
                    results_tag_inner.className += " scrollable";
                }

                results_inner.appendChild(results_tag_inner);
            }

            if (obj.name === "result_label") {
                var results_ul = document.querySelector('.' + markup.results_ul.attrs.class);
                var results_label_tag = document.createElement(markup.result_label.tag)

                if (passDatas && passDatas.title) {
                    results_label_tag.textContent = ' ' + passDatas.title + ' ';
                    results_label_tag.setAttribute('aria-label', passDatas.title)
                }

                var attrs = markup.result_label.attrs;
                this.generateAttr(results_label_tag, attrs);
                results_ul.appendChild(results_label_tag);
            }

            if (obj.name === "no_results") {
                var results_ul = document.querySelector('.' + markup.results_ul.attrs.class);
                var no_results = document.createElement(markup.no_results.tag)

                if (passDatas && passDatas.title) {
                    no_results.textContent = passDatas.title;
                    no_results.setAttribute('aria-label', passDatas.title)
                }

                var attrs = markup.no_results.attrs;
                this.generateAttr(no_results, attrs);
                results_ul.appendChild(no_results);
            }

            if (obj.name === "result") {
                var results_ul = document.querySelector('.' + markup.results_ul.attrs.class);
                var results_li_tag = document.createElement(markup.result.tag)

                // if(passDatas) {
                //     console.log('passDatas', passDatas)
                // }
                var attrs = markup.result.attrs;
                this.generateAttr(results_li_tag, attrs);

                switch (passDatas.reference) {
                    case "regions":
                        results_li_tag.setAttribute('data-rid', passDatas.src.id);
                        results_li_tag.setAttribute('data-pid', passDatas.src.pays_id);

                        results_li_tag.textContent = passDatas.src.libelle;
                        break;
                    case "departements":
                        if (passDatas.src._needCp === true) {
                            results_li_tag.classList.add('has-cp');
                        }
                        results_li_tag.setAttribute('data-rid', passDatas.src.region_id);
                        results_li_tag.setAttribute('data-pid', passDatas.src.pays_id);
                        results_li_tag.setAttribute('data-did', passDatas.src.id);
                        results_li_tag.setAttribute('data-code-postal', passDatas.src.code_postale);

                        if (passDatas.src._needCp === true) {
                            // console.log('passDatas.src needCp true', passDatas.src)
                            results_li_tag.innerHTML = passDatas.src.libelle + '<br><span class="cp d-block small"> ' + passDatas.src.code_postale + '</span>';
                        } else {
                            // console.log('passDatas.src needCp false', passDatas.src)
                            results_li_tag.textContent = passDatas.src.libelle;
                        }

                        break;
                    case "magasins":
                        if (passDatas.src._needCp === true) {
                            results_li_tag.classList.add('has-cp');
                        }
                        results_li_tag.setAttribute('data-rid', passDatas.src.region_id);
                        results_li_tag.setAttribute('data-pid', passDatas.src.pays_id);
                        results_li_tag.setAttribute('data-did', passDatas.src.departement_id);
                        results_li_tag.setAttribute('data-code-postal', passDatas.src.code_postal);
                        results_li_tag.setAttribute('data-mid', passDatas.src.id);
                        if (passDatas.src._needCp === true) {
                            results_li_tag.innerHTML = passDatas.src.nom + '<br><span class="cp d-block small"> ' + passDatas.src.code_postal + '</span>';
                        } else {
                            results_li_tag.textContent = passDatas.src.nom;
                        }

                        break;
                }
                results_li_tag.setAttribute('data-reference', passDatas.reference);


                results_ul.appendChild(results_li_tag);
            }

            if (obj.name === "result_string_match") {
                var results__exlude_labels = document.querySelectorAll('.' + markup.result.attrs.class + '[data-reference="' + passDatas.reference + '"]:not(.' + markup.result_label.attrs.class + ')');
                var inputVal = this.options.value;

                //console.log('inputVal', inputVal)

                for (let index = 0; index < results__exlude_labels.length; index++) {
                    var li_passed = results__exlude_labels[index];
                    var text = li_passed.textContent.toLowerCase();

                    var matched_point = this.options.latinize(text).indexOf(this.options.latinize(inputVal));
                    //console.log(matched_point);
                    // console.log('li_passed cp', li_passed)
                    // console.log('li_passed cp child one', li_passed.childNodes[1])
                    // console.log('is cp ?', this.isCp(li_passed))
                    // console.log('has cp ?', this.hasCp(li_passed))


                    if (this.isCp(li_passed) && this.hasCp(li_passed) === true) {
                        // console.log('a')
                        var data_cp = li_passed.getAttribute('data-code-postal');
                        var cp = li_passed.querySelector('.cp');
                        // console.log('li_passed cp', li_passed)
                        // console.log('cp', cp)
                        // cp
                        var cp_matched_by_input = cp.textContent.trim().toLowerCase().indexOf(inputVal);
                        // console.log('cp.textContent',cp.textContent)
                        // console.log('cp_matched_by_input',cp_matched_by_input)
                        // console.log('who\'s text', text)
                        var cp_matched_by_text = text.indexOf(data_cp.toLowerCase());
                        // console.log('cp_matched_by_text', cp_matched_by_text)
                        // console.log('matched_point cp', matched_point)
                        // console.log('inputVal cp', inputVal)
                        // console.log('text.substr(cp_matched, matched_point).toLowerCase()', text.substr(cp_matched_by_text, matched_point).toLowerCase())

                        if (cp_matched_by_input === cp_matched_by_text) {
                            var text_spl = text.split(' ');
                            li_passed.innerHTML = "";
                            li_passed.innerHTML = " " + text_spl[0].charAt(0).toUpperCase() + text_spl[0].substr(1, text_spl[0].length).toLowerCase() + "<br><p class='small d-block mb-0'>" + data_cp.substr(0, cp_matched_by_input).toLowerCase() + "<span class='" + markup.result_string_match.attrs.class + "'> " + data_cp.substr(cp_matched_by_input, inputVal.length).toLowerCase() + "</span>" + data_cp.substr((cp_matched_by_input + inputVal.length), cp.length).toLowerCase() + "</p>";
                            // cas like bruxelles / bramard et toussa
                            // le binding se fera sur le code postal par défaut car dans la logique du plugin . Nous rentrons dans les départements qui ont besoin de souligner le codepostal
                        } else {
                            li_passed.innerHTML = "";
                            li_passed.innerHTML = " " + text.substr(0, cp_matched_by_text).toLowerCase() + "<br><p class='small d-block mb-0'> " + data_cp.substr(0, cp_matched_by_input).toLowerCase() + "<span class='" + markup.result_string_match.attrs.class + "'>" + data_cp.substr(cp_matched_by_input, inputVal.length).toLowerCase() + "</span>" + data_cp.substr((cp_matched_by_input + inputVal.length), cp.length).toLowerCase() + "</p>";
                        }

                    } else if (this.isCp(li_passed) && this.hasCp(li_passed) === false) {
                        // console.log('b')
                        // console.log('li_passed cp', li_passed)
                        // li_passed.innerHTML = "GROSSE TATA";
                        // li_passed.innerHTML = "";
                    } else {
                        //console.log('c')
                        li_passed.innerHTML = "";
                        li_passed.innerHTML = "" + text.substr(0, matched_point).toLowerCase() + "<span class='" + markup.result_string_match.attrs.class + "'>" + text.substr(matched_point, inputVal.length).toLowerCase() + "</span>" + text.substr((matched_point + inputVal.length), text.length).toLowerCase() + "  ";

                    }
                    // console.log('textContent', text);
                    // console.log('text with HTML', li_passed.innerHTML);
                    // console.log('test text with HTML indexOf', li_passed.innerHTML.indexOf(inputVal));

                    // console.log('matched_point', matched_point)

                }

                // console.log('results__exlude_labels', results__exlude_labels)
            }

            if (obj.name === "overlay") {
                var markup = this.get('markup');
                var overlay = document.createElement(markup.overlay.tag);

                var attrs = markup.overlay.attrs;
                this.generateAttr(overlay, attrs);

                document.body.appendChild(overlay);
            }

        }




        this.hooks.addCreateRenderer();

        // document.appendChild(frag);
    }
    hasCp(node) {
        // console.log('hascp node', node)
        // console.log('hasCp function', node.querySelector('.cp'))
        return node.contains(node.querySelector('.cp'));
    }
    isCp(node) {
        return node.classList.contains('has-cp');
    }
    isOpenCarto() {
        var form_wrapper = document.querySelector(this.options.elements.form_wrapper);

        return form_wrapper.classList.contains('show_carto');

    }
    getPaysIdByLang() {
        let l = document.documentElement.lang;
        let idPays = 0;
        switch (l) {
            case 'de':
                idPays = '46'
                break;
            case 'fr':
                idPays = '58'
                break;
            case 'es':
                idPays = '54'
                break;
            case 'nl':
                idPays = '15'
                break;
        }
        return idPays;
    }
    openCarto() {
        var form_wrapper = document.querySelector(this.options.elements.form_wrapper);
        let home_magasin_id = this.getFromLocalStorage('home_magasin_id');

        let paysIdFromDoc = this.getPaysIdByLang();

        let havePaysId = this.getFromLocalStorage('home_pays_id');

        if(havePaysId == null) {
            havePaysId = 0;
        }

        form_wrapper.classList.add('show_carto');
        if (this.map == undefined) {
            setTimeout(() => {
                this.loadMap(havePaysId != null ? havePaysId : paysIdFromDoc);
            }, 300)
        }

        if (home_magasin_id != null) {
            setTimeout(() => {
                let mag = [this.getMagasin(home_magasin_id)];
                let bounds = this.getBounds(mag);
                // [pays.lat, pays.lng]
                this.map.fitBounds(bounds, {animation:false});
            }, 300)

        }
        this.hooks.showMap();
    }
    closeCarto() {
        var form_wrapper = document.querySelector(this.options.elements.form_wrapper);
        this.hooks.hideMap();
        form_wrapper.classList.remove('show_carto');
    }
    toggleCarto() {
        var form_wrapper = document.querySelector(this.options.elements.form_wrapper);
        form_wrapper.classList.contains('show_carto') ? this.hooks.hideMap() : this.hooks.showMap();
        form_wrapper.classList.toggle('show_carto');
    }
    hasFilteredResults() {
        let res = false;
        let results = this.options.store.filter_datas
        let resultKeys = Object.keys(results);
        resultKeys.forEach((resultKey) => {
            if(results[resultKey].length > 0) {
                res = true;
            }
        })
        return res;
    }
    registerListeners() {
        var input = this.getElement('input');
        // var search_text = document.querySelector(this.options.elements.search_text);
        var select = this.getElement('select');
        var magasins_close_overlay = this.getElement('magasins_close_overlay');
        // var close_overlay = document.querySelector('.js-close-overlay');
        var geoloc = this.getElement('geoloc');
        var markup = this.get('markup');
        let magasins_overlay = this.getElement('magasins_overlay');
        // console.log()
        var that = this;

        let paysIdFromDoc = this.getPaysIdByLang();


        var toggle_overlay_magasins = this.getElement('toggle_overlay_magasins');
        let fakebtnsubmit = that.getElement('toggle_overlay_magasins');

        if (toggle_overlay_magasins != undefined) {
            toggle_overlay_magasins.addEventListener('click', function (e) {
                e.preventDefault();
                let havePaysId = that.getFromLocalStorage('home_pays_id');
                
                if(havePaysId == null) {
                    havePaysId = 0;
                }

                that.toggleCarto();
                setTimeout(() => {
                    if (that.map == undefined) {
                        that.loadMap( havePaysId != null ? havePaysId : paysIdFromDoc);
                    }
                }, 300)
            })
        }


        if (geoloc != undefined) {
            geoloc.addEventListener('click', function (e) {
                e.preventDefault();
                that.requestGeoloc(true);
            })
        }

        if (select != undefined) {
            select.addEventListener('change', function (e) {
                // console.log('this instance', that);
                if (that.map != undefined && magasins_overlay != undefined) {
                    that.loadMap();
                }
                if (that.isOpenCarto() == false && magasins_overlay != undefined) {
                    that.openCarto();
                }
                // that.openCarto();
                if(fakebtnsubmit != undefined) {
                    fakebtnsubmit.style.display = '';
                }

                that.hooks.onChange(that);

            })
        }

        // select.addEventListener('focus', function(e) {
        //     var winWidth = window.innerWidth;
        //     var is_open = that.isOpenedOverlay();

        // })
        if (magasins_close_overlay != undefined) {
            magasins_close_overlay.addEventListener('click', function (e) {
                e.preventDefault();
                that.closeCarto();
            })
        }

        if (input != undefined) {
            input.addEventListener('keyup', function (e) {
                that.options.value = input.value.trim().toLowerCase();

                // if(that.options.value.length === 0) {
                that.options.suggestion = '';
                // }
                var obj = {
                    input: that.options.value.trim().toLowerCase(),
                    select: select.options[select.selectedIndex]
                }

                // Si input vide, on vire les datas en memoire :
                if (obj.input === "") {
                    that.clearFromLocalStorage('for_search_field');
                    that.clearFromLocalStorage('home_magasin_name');
                    that.clearFromLocalStorage('home_magasin_id');
                    that.clearFromLocalStorage('home_departement_name');
                    that.clearFromLocalStorage('home_departement_id');
                    that.clearFromLocalStorage('home_region_name');
                    that.clearFromLocalStorage('home_region_id');

                    // localStorage.removeItem('for_search_field');
                    // localStorage.removeItem('home_magasin_name');
                    // localStorage.removeItem('home_magasin_id');
                    // localStorage.removeItem('home_departement_name');
                    // localStorage.removeItem('home_departement_id');
                    // localStorage.removeItem('home_region_name');
                    // localStorage.removeItem('home_region_id');

                    if(fakebtnsubmit != undefined) {
                        fakebtnsubmit.style.display = '';
                    }

                    document.querySelector('#myawesome_region').value = '';
                    document.querySelector('#myawesome_departement').value = '';
                    document.querySelector('#myawesome_magasin').value = '';
                    document.querySelector('#myawesome_pays').value = that.options.store.select_pays_id;

                    let havePaysId = that.getFromLocalStorage('home_pays_id');

                    if(havePaysId == null) {
                        havePaysId = 0;
                    }

                    that.loadMap( havePaysId != null ? havePaysId : paysIdFromDoc);

                    // setTimeout(() => {
                    //     if (that.map == undefined) {
                    //         that.loadMap( havePaysId != null ? havePaysId : paysIdFromDoc);
                    //     }
                    // }, 300)
                }

                that.hooks.onTyping();
                if (that.options.value.length >= that.options.researchStart) {
                    if (e.keyCode != 39 && e.keyCode != 38 && e.keyCode != 37 && e.keyCode != 40 && e.keyCode != 16) {
                        // setTimeout(function() {
                        if (that.onSearch === false) {
                            
                            that.onSearch = true;
                            that.loadResearch(obj);
                            
                            if(that.hasFilteredResults()) {
                                that.open();
                                that.loadResultsEvent();
                            }
                            that.hooks.onFinishedResearch(that, that.options.store.filter_datas);
                           
                            
                            setTimeout(function () {
                                that.onSearch = false;
                            }, 100)

                        }

                        // }, 400)

                    }

                } else {
                    that.close();
                }

            })
            input.addEventListener('keydown', function (e) {
                that.options.value = input.value.trim().toLowerCase();
                var results_ul = document.querySelector('.results_ul')


                if (results_ul.hasChildNodes()) {
                    if (e.keyCode != 39 && e.keyCode != 38 && e.keyCode != 37 && e.keyCode != 40 && e.keyCode != 16) {
                        var results_ul_childnodes = results_ul.childNodes;
                        results_ul_childnodes_arr = Array.prototype.slice.call(results_ul_childnodes);

                        for (let index = 0; index < results_ul_childnodes_arr.length; index++) {
                            const children = results_ul_childnodes_arr[index];
                            children.parentNode.removeChild(children);

                        }
                    }
                }
            })

            input.addEventListener('blur', function (e) {
                that.hooks.onBlur(that);
            });

            input.addEventListener('focus', function (e) {

                if (that.isOpenCarto() == false && magasins_overlay != undefined) {
                    that.openCarto();
                }

                that.options.value = input.value.trim().toLowerCase();
                var results_ul = document.querySelector('.results_ul')

                var obj = {
                    input: that.options.value.trim().toLowerCase(),
                    select: select.options[select.selectedIndex]
                }

                that.hooks.onFocus(that);

                if (results_ul.hasChildNodes()) {
                    var results_ul_childnodes = results_ul.childNodes;
                    results_ul_childnodes_arr = Array.prototype.slice.call(results_ul_childnodes);

                    for (let index = 0; index < results_ul_childnodes_arr.length; index++) {
                        const children = results_ul_childnodes_arr[index];
                        children.parentNode.removeChild(children);
                    }
                    that.loadResearch(obj);

                    if(that.hasFilteredResults()) {
                        that.open();
                        that.loadResultsEvent();
                    }
                    that.hooks.onFinishedResearch(that, that.options.store.filter_datas);
                    
                }

            })

            document.addEventListener('click', function (e) {
                var is_open = that.isOpened();
                var childCheck = document.getElementById(that.options.markup.wrapper.attrs.id).contains(e.target);
                //    console.log('childCheck', childCheck)
                if (is_open && childCheck === false) {
                    that.close();
                    var hasSuggest = that.hasSuggestion();
                    // console.log('hasSuggest', hasSuggest)
                    // console.log('hasSuggest input', input)
                    if (hasSuggest === false) {
                        var results_ul = document.querySelector('.results_ul')


                        if (results_ul.hasChildNodes()) {
                            var results_ul_childnodes = results_ul.childNodes;
                            results_ul_childnodes_arr = Array.prototype.slice.call(results_ul_childnodes);

                            for (let index = 0; index < results_ul_childnodes_arr.length; index++) {
                                const children = results_ul_childnodes_arr[index];
                                children.parentNode.removeChild(children);

                            }
                        }
                    }
                }
            })
        }


        if (select != undefined) {
            select.addEventListener('change', function (e) {
                that.options.store.select_pays_id = parseInt(select.options[select.selectedIndex].getAttribute('data-pid'));
                // console.log(' this.options.store.select_pays_id',  that.options.store.select_pays_id)
                var results_ul = document.querySelector('.results_ul')

                var p_field = that.retrieve('pays', parseInt(that.options.store.select_pays_id));
                // console.log('p_field', p_field)

                if (that.options.store.select_pays_id != 0) {
                    that.setToLocalStorage('home_pays_name', p_field.libelle);
                    that.setToLocalStorage('home_pays_id', that.options.store.select_pays_id);
                } else {
                    that.clearFromLocalStorage('home_pays_name');
                    that.clearFromLocalStorage('home_pays_id');
                }

                that.setToLocalStorage('search_type', 'pays');

                that.clearFromLocalStorage('for_search_field');
                that.clearFromLocalStorage('home_magasin_name');
                that.clearFromLocalStorage('home_magasin_id');

                that.clearFromLocalStorage('home_departement_name');
                that.clearFromLocalStorage('home_departement_id');

                that.clearFromLocalStorage('home_region_name');
                that.clearFromLocalStorage('home_region_id');

                input.value = '';

                document.querySelector('#myawesome_region').value = '';
                document.querySelector('#myawesome_departement').value = '';
                document.querySelector('#myawesome_magasin').value = '';
                document.querySelector('#myawesome_pays').value = that.options.store.select_pays_id;

                if (results_ul.hasChildNodes()) {
                    var results_ul_childnodes = results_ul.childNodes;
                    results_ul_childnodes_arr = Array.prototype.slice.call(results_ul_childnodes);

                    for (let index = 0; index < results_ul_childnodes_arr.length; index++) {
                        const children = results_ul_childnodes_arr[index];
                        children.parentNode.removeChild(children);
                    }




                }
            })
        }




    }
    isOpened() {
        var wrapper = document.querySelector('.' + this.options.markup.wrapper.attrs.class);
        return wrapper.classList.contains('is-open');
    }
    sendInformations(element) {
        // console.log(element);
        // var getRef = element.getAttribute('data-reference');
        var r_id = element.getAttribute('data-rid');
        var m_id = element.getAttribute('data-mid');
        var p_id = element.getAttribute('data-pid');
        var d_id = element.getAttribute('data-did');

        var ref = element.getAttribute('data-reference');

        console.log('ref', ref)

        // console.log('r_id', r_id)
        // console.log('d_id', d_id)
        // console.log('m_id', m_id)
        // console.log('p_id', p_id)
        if (r_id != null) {
            document.querySelector('#myawesome_region').value = r_id;
            var region_field = this.retrieve('regions', parseInt(r_id));

            // localStorage.setItem('home_region_name', element.textContent);
            // localStorage.setItem('home_region_id', r_id);
        }
        if (d_id != null) {
            document.querySelector('#myawesome_departement').value = d_id;
            var dep_field = this.retrieve('departements', parseInt(d_id));

        }
        if (m_id != null) {
            document.querySelector('#myawesome_magasin').value = m_id;
            var m_field = this.retrieve('magasins', parseInt(m_id));

        }
        if (p_id != null) {
            document.querySelector('#myawesome_pays').value = p_id;
            var p_field = this.retrieve('pays', parseInt(p_id));

        }



        switch (ref) {
            case "magasins":
                // console.log('m_field', m_field)
                this.setToLocalStorage('home_magasin_name', m_field.nom);
                this.setToLocalStorage('home_magasin_id', m_id);

                this.setToLocalStorage('for_search_field', m_field.nom);

                var dep_field = this.retrieve('departements', parseInt(d_id));
                // console.log('dep_field', dep_field)
                this.setToLocalStorage('home_departement_name', dep_field.libelle);
                this.setToLocalStorage('home_departement_id', d_id);

                var region_field = this.retrieve('regions', parseInt(r_id));
                // console.log('region_field', region_field)

                this.setToLocalStorage('home_region_name', region_field.libelle);
                this.setToLocalStorage('home_region_id', r_id);

                this.setToLocalStorage('home_pays_name', p_field.libelle);
                this.setToLocalStorage('home_pays_id', p_id);

                this.setToLocalStorage('search_type', ref);

                this.options.store.select_pays_id = parseInt(p_id);
                // console.log('this', this)
                break;
            case "departements":
                // console.log('dep_field', dep_field)
                // localStorage.setItem('home_departement_name', dep_field.libelle);

                this.setToLocalStorage('home_departement_id', d_id);
                this.setToLocalStorage('home_region_id', r_id);
                this.setToLocalStorage('home_pays_id', p_id);

                this.clearFromLocalStorage('home_magasin_id');

                this.setToLocalStorage('for_search_field', dep_field.libelle);

                break;
            case "regions":
                // console.log('region_field', region_field)
                // localStorage.setItem('home_region_name', region_field.libelle);

                this.setToLocalStorage('home_region_id', r_id);
                this.setToLocalStorage('home_pays_id', p_id);
                this.setToLocalStorage('for_search_field', region_field.libelle);

                this.clearFromLocalStorage('home_departement_id');
                this.clearFromLocalStorage('home_magasin_id');

                break;

            default:
                // console.log('p_field', p_field)
                this.setToLocalStorage('home_pays_name', p_field.libelle);
                this.setToLocalStorage('home_pays_id', p_id);
                this.setToLocalStorage('search_type', ref);
                break;
        }

        // On supprimme les valeurs vide :

        // console.log('p_field',p_field);
        // console.log('region_field',region_field);
        // console.log('dep_field',dep_field);
        // console.log('m_field',m_field);


        this.hooks.onChange(this);
    }
    getBounds(magasins) {
        let ret = [];
        //console.log('magasins', magasins)
        for (let index = 0; index < magasins.length; index++) {
            const magasin = magasins[index];
            let arrayOfCoords = [];
            arrayOfCoords.push(magasin.lat);
            arrayOfCoords.push(magasin.lng);
            ret.push(arrayOfCoords);
        }
        //console.log(ret)
        return ret;
    }
    loadResultsEvent() {
        var results = document.querySelectorAll('.' + this.options.markup.result.attrs.class);
        // console.log('.'+this.options.markup.result.attrs.class);
        // console.log(results);
        var that = this;
        var results_arr = Array.prototype.slice.call(results);
        let magasins_overlay = this.getElement('magasins_overlay');

        for (let index = 0; index < results_arr.length; index++) {
            const result = results_arr[index];
            result.addEventListener('click', function (e) {
                // console.log('click', e);
                that.hooks.onSelect();
                that.sendInformations(this);
                that.changeInformations(this);
                //console.log(this);
                let filterMag = undefined;
                let filterDataMag = undefined;
                let mag = undefined;

                let ref = this.getAttribute('data-reference');

                if (ref === 'magasins') {
                    filterDataMag = this.getAttribute('data-mid');
                    mag = [that.getMagasin(filterDataMag)];
                    that.hooks.onSelectMagasin(that, mag[0]);
                    let fakebtnsubmit = that.getElement('toggle_overlay_magasins');
                    console.log('fakebtnsubmit', fakebtnsubmit)
                    if(fakebtnsubmit != undefined) {
                        fakebtnsubmit.style.display = 'none';
                    }
                }

                if (ref === 'departements' && magasins_overlay != undefined) {
                    filterDataMag = this.getAttribute('data-did');
                    // console.log('filterDataMag', filterDataMag)
                    mag = that.filterMagasinsBy('departement_id', parseInt(filterDataMag));
                    // console.log('mag', mag)
                }

                if (ref === 'regions' && magasins_overlay != undefined) {
                    filterDataMag = this.getAttribute('data-rid');
                    mag = that.filterMagasinsBy('region_id',  parseInt(filterDataMag));
                }

                //console.log('mag', mag)

                if (mag.length > 0 && magasins_overlay != undefined) {
                    let bounds = that.getBounds(mag);

                    that.map.fitBounds(bounds);
                }


                if (ref === 'regions' || ref === 'departements') {

                    that.clearSelection();
                }

                if (ref === 'magasins' && magasins_overlay != undefined) {
                    that.bindPopup(this.getAttribute('data-mid'));
                }




            })

        }
    }
    hasSuggestion() {
        let rt = false;

        if (this.options.suggestion.length > 0) {
            rt = true;
        }
        return rt;
    }
    changeInformations(elm) {
        // console.log('change information elm', elm);
        var text = elm.textContent.trim();
        var final_text;

        if (this.isCp(elm)) {
            // console.log('cp', elm)
            final_text = elm.childNodes[0].nodeValue.trim();
            // console.log('final_text', final_text)
        } else {
            final_text = text.trim();
        }
        // console.log('text', text);
        var input = document.querySelector(this.options.elements.input);

        input.value = final_text.charAt(0).toUpperCase() + final_text.substr(1, final_text.length).toLowerCase();
        this.options.suggestion = final_text;
        this.close();
    }
    close() {
        var results = document.querySelector('.' + this.options.markup.results.attrs.class);
        var wrapper = document.querySelector('.' + this.options.markup.wrapper.attrs.class);
        this.hooks.beforeClose();
        results.setAttribute('hidden', 'hidden');

        wrapper.classList.remove('is-open');
        this.hooks.close();
    }
    open() {
        var results = document.querySelector('.' + this.options.markup.results.attrs.class);
        var wrapper = document.querySelector('.' + this.options.markup.wrapper.attrs.class);
        this.hooks.beforeOpen();
        results.removeAttribute('hidden', 'hidden');
        this.hooks.open();

        // wrapper.className += " is-open";
        wrapper.classList.add('is-open');

    }
    canBeCodePostal(source, matching) {
        return source.trim().toLowerCase().indexOf(matching)
    }
    canBeCodeFromStart(source, matching) {

        let matchStr = source.trim().toLowerCase().indexOf(matching);

        if (matchStr === 0) {
            return 0;
        } else {
            return -1;
        }
    }

    getCodePostalCheckByPays(pays_id) {

        let default_end = 2;
        
        switch (pays_id) {
            case 46:
                default_end = 3;
                break;
            case 58:
                default_end = 2;
                break;
            case 54:
                default_end = 3;
                break;
            case 15:
                default_end = 3;
                break;
        }
        return default_end;
    }
    // determineSearch(searchable) {
    //     let isNAN = isNaN(searchable);
    //     let canBeCp = this.canBeCodePostal(searchable, source.code_postal);
    //     let canBePossibleCp = this.canBeCodeFromStart(source.code_postal, obj.input.substring(0, 2));
    // }
    loadResearch(obj, renderable = true) {
        obj.input = this.options.latinize(obj.input)

        let APIDATAS;
        // const APIDATAS = this.options.store.datas;
        if (navigator.userAgent.indexOf('MSIE') !== -1 ||
            navigator.appVersion.indexOf('Trident/') > -1) {
            /* Microsoft Internet Explorer detected in. */
            APIDATAS = JSON.parse(this.options.store.datas);
        } else {
            APIDATAS = this.options.store.datas;
        }

        // researchOn
        let APIDATAS_CORRECT_ORDER = {}
        if(this.options.researchOn.length > 0) {

            for (let index = 0; index < this.options.researchOn.length; index++) {
                const researchKey = this.options.researchOn[index];

                APIDATAS_CORRECT_ORDER[researchKey] = APIDATAS[researchKey];

            }
        }

        // console.log('APIDATAS_CORRECT_ORDER', APIDATAS_CORRECT_ORDER)

        // const APIDATAS_CORRECT_ORDER = {
        //     magasins: APIDATAS.magasins,
        //     departements: APIDATAS.departements,
        //     regions: APIDATAS.regions
        // }
        // const FILTEREDDATAS = this.options.store.filter_datas;
        // var APIDATASKEYS = Object.keys(APIDATAS);
        this.options.store.filter_datas = {};

        let APIDATAS_CORRECT_ORDER_KEY = Object.keys(APIDATAS_CORRECT_ORDER);
        // console.log('APIDATAS_CORRECT_ORDER', APIDATAS_CORRECT_ORDER)

        for (let index = 0; index < APIDATAS_CORRECT_ORDER_KEY.length; index++) {
            let key = APIDATAS_CORRECT_ORDER_KEY[index];

            var local_source = APIDATAS_CORRECT_ORDER[key];
            // console.log('key type search', key)
            this.options.store.filter_datas[key] = [];
            var local_index = 0;

            // et oui je suis amateur de sucrerie aussi !
            for (let kinder = 0; kinder < local_source.length; kinder++) {
                const source = local_source[kinder];
                var matching = '';
                let canBeCp = '';
                let canBePossibleCp = '';
                var searchScope = obj.input;
                let end_cp_check = null;

                switch (key) {
                    case 'magasins':
                        let isNAN = isNaN(obj.input);
                        end_cp_check = this.getCodePostalCheckByPays(source.pays_id);
                        canBeCp = this.canBeCodePostal(obj.input, source.code_postal);
                        canBePossibleCp = this.canBeCodeFromStart(source.code_postal, obj.input.substring(0, end_cp_check));

                        // console.log('canBeCp', canBeCp)
                        // console.log('canBePossibleCp', canBePossibleCp)
                        // console.log('obj.input', obj.input)
                        // console.log('source.code_postal', source.code_postal)


                        if (canBePossibleCp > -1 && isNAN == false && canBeCp === -1) {

                            matching += this.options.latinize(source.code_postal.trim())
                            source._needCp = true;
                            source._isPossibleCp = true;
                            source._needStringMatching = false;
                            searchScope = obj.input.substring(0, 2);
                        }

                        if (isNAN == false && canBePossibleCp === -1 && canBeCp > -1 ||
                            isNAN == false && canBePossibleCp > -1 && canBeCp > -1) {
                            matching += this.options.latinize(source.code_postal.trim())
                            source._needCp = true;
                            source._isPossibleCp = false;
                            source._needStringMatching = true;
                            searchScope = obj.input;
                        }

                        if (isNAN == true) {

                            if (canBePossibleCp > -1) {
                                matching += this.options.latinize(source.code_postal.trim())
                                source._needStringMatching = true;
                                source._isPossibleCp = true;
                                source._needCp = true;
                                // console.log('matching', matching)
                                // console.log('searchScope', searchScope)
                            } else {
                                matching += this.options.latinize(source.nom.trim().toLowerCase())
                                source._needStringMatching = true;
                                source._isPossibleCp = false;
                                source._needCp = false;
                                searchScope = obj.input;
                            }

                        }



                        break;
                    case 'departements':

                        end_cp_check = this.getCodePostalCheckByPays(source.pays_id);
                        canBeCp = this.canBeCodePostal(source.code_postale, obj.input);
                        canBePossibleCp = this.canBeCodeFromStart(source.code_postale, obj.input.substring(0, end_cp_check));




                        if (canBeCp > -1 && canBePossibleCp === -1) {
                            matching += source.code_postale.trim().toLowerCase();
                            source._needCp = true;
                            source._isPossibleCp = false;
                            source._needStringMatching = true;
                            searchScope = obj.input;
                        }

                        if (canBeCp > -1 && canBePossibleCp > -1) {
                            matching += source.code_postale.trim().toLowerCase();
                            source._needCp = true;
                            source._isPossibleCp = true;
                            source._needStringMatching = true;
                            // console.log('possible ?', matching)
                            searchScope = obj.input;
                        }


                        if (canBeCp === -1 && canBePossibleCp > -1) {
                            matching += source.code_postale.trim().toLowerCase();
                            source._needCp = true;
                            source._isPossibleCp = true;
                            source._needStringMatching = false;
                            // console.log('possible ?', matching)
                            searchScope = obj.input.substring(0, 2);
                        }

                        if (canBeCp === -1 && canBePossibleCp === -1) {
                            matching += this.options.latinize(source.libelle.trim().toLowerCase())
                            source._needStringMatching = true;
                            source._needCp = false;
                            searchScope = obj.input;
                        }





                        break;
                    case 'regions':
                        matching += this.options.latinize(source.libelle.trim().toLowerCase())
                        source._needStringMatching = true;
                        source._needCp = false;
                        searchScope = obj.input;
                        break;

                    default:
                        console.log('undefined typed data');
                        break;
                }

                var n;
                //Matching operation start here
                n = matching.toLowerCase().indexOf(searchScope);


                if (n != -1) {
                    if (this.options.store.select_pays_id != 0 && source.pays_id === this.options.store.select_pays_id) {
                        this.options.store.filter_datas[key][local_index] = source;
                        local_index++;
                    } else if (this.options.store.select_pays_id === 0) {
                        this.options.store.filter_datas[key][local_index] = source;
                        local_index++;
                    }
                }
            }


        }
        // console.log(this.options.store.filter_datas)
        if(renderable) {
            this.render();
        }
    }
    getFilteredDatas() {
        return this.options.store.filter_datas;
    }
    render() {
        var filteredDatas = this.options.store.filter_datas;
        var countable_fields = 0;
        var markup = this.options.markup;
        for (const data in filteredDatas) {
            if (filteredDatas.hasOwnProperty(data)) {
                const filtered_local_source = filteredDatas[data];

                if (filtered_local_source.length > 0) {

                    // give labels with options

                    if(this.options.enableTitlesResults) {
                        this.create(markup.result_label, {
                            title: this.options.labels[data]
                        });
                    }


                    for (let index = 0; index < filtered_local_source.length; index++) {
                        const local = filtered_local_source[index];
                        // console.log('data ref', data)
                        // console.log('cibled ref',  this.options.labels[data] )
                        this.create(markup.result, {
                            src: local,
                            reference: data
                        });
                        if (local._needStringMatching === true) {
                            this.create(markup.result_string_match, {
                                src: local,
                                reference: this.options.labels[data]
                            });
                        }
                    }

                }
                if (filtered_local_source.length === 0) {
                    countable_fields++;
                }

            }
        }
        // console.log('countable_fields', countable_fields)
        // console.log('filteredDatas.length', filteredDatas.length)
        if (countable_fields === Object.keys(filteredDatas).length) {
            this.create(markup.no_results, {
                title: this.options.labels.noresults
            });
        }

    }

    setCenterSearch(data) {
        if (data.length > 0 && data[0].place_id) {

            result = data[0];
            var poslat = result.lat;
            var poslng = result.lon;
            var zoom = 8;
            if($(window).width() < 993) {
                zoom = 7;
            }
            this.map.setView([poslat, poslng], zoom);
        }
    }

    

}

module.exports = rechercheUi;
